import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { ProductsRes } from 'features/products/types/products.types'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchProducts = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const {
		data: products,
		isFetching: isProductsLoading,
		isSuccess: isProductsSuccess
	} = useQuery<ProductsRes>({
		queryKey: queryKeys.products.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.products(query)),
		enabled: !!auth.accessToken
	})

	return {
		products,
		isProductsLoading,
		isProductsSuccess
	}
}
